type AmountOption = {
  id: number;
  amount: number;
  isSelected: boolean;
};

export const amountOptions: AmountOption[] = [
  {
    id: 0,
    amount: 10,
    isSelected: false,
  },
  {
    id: 1,
    amount: 25,
    isSelected: false,
  },
  {
    id: 2,
    amount: 50,
    isSelected: false,
  },
  {
    id: 3,
    amount: 100,
    isSelected: false,
  },
];
